import { useState, useEffect } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { ArrowBack, Dashboard, Business } from "@material-ui/icons";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import styled, { createGlobalStyle, keyframes } from "styled-components";
import fetchClient from "../api/fetchClient";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Mulish:wght@200;300;400;500;600;700;800;900&display=swap');

  html, body, #root {
    margin: 0;
    padding: 0;
    width: 100%;
    min-height: 100%;
    overflow-x: hidden;
    font-family: 'Mulish', sans-serif;
    background: #f5f7fa;
    box-sizing: border-box;
  }

  *, *::before, *::after {
    box-sizing: inherit;
  }
`;

const cardsConfig = [
  {
    name: "",
    permission: "e1",
    image: "/image/e1_logo.png",
    subcards: [
      {
        name: "Dashboard",
        image: "/image/icondashboard.png",
        href: "/e1/dashboard",
        permission: "e1-dashboard",
      },
      {
        name: "Dashboard Consolidado",
        image: "/image/consolidate.png",
        href: "/e1/dashboard-consolidado",
        permission: "e1-dashboard-consolidado",
      },
    ],
  },
  {
    name: "",
    permission: "seidor",
    image: "/image/logo-default.png",
    subcards: [
      {
        name: "Dashboards",
        image: "/image/icondashboard.png",
        href: "/seidor/dashboard",
      },
      {
        name: "Aplicações",
        image: "/image/iconapp.png",
        href: "/seidor/aplicacao",
      },
    ],
  },
  {
    name: "Concur",
    permission: "concur",
    image: "/image/logo-sap-concur.png",
    countKey: "concur",
    subcards: [
      {
        name: "Empresas",
        image: "/image/iconapp.png",
        href: "/concur/empresas",
        permission: "concur-empresas",
      },
      {
        name: "Dashboard",
        image: "/image/icondashboard.png",
        href: "/concur/dashboard",
        permission: "concur-dashboard",
      },
      {
        name: "Concur",
        image: "/image/SAP-Concur.png",
        href: "/concur",
        permission: "concur-config",
      },
      {
        name: "Logs",
        image: "/image/logs.png",
        href: "/concur/logs",
        permission: "concur-logs",
      },
    ],
  },
  {
    name: "Viceri",
    permission: "viceri",
    image: "/image/viceri.png",
    countKey: "viceri",
    subcards: [
      {
        name: "Dashboard",
        image: "/image/icondashboard.png",
        href: "/viceri/dashboard",
        permission: "viceri-dashboard",
      },
      {
        name: "Aplicações",
        image: "/image/iconapp.png",
        href: "/viceri/aplicacoes",
        permission: "viceri-aplicacoes",
      },
      {
        name: "Logs",
        image: "/image/logs.png",
        href: "/viceri/logs",
        permission: "viceri-logs",
      },
    ],
  },
  {
    name: "",
    permission: "comerzzia",
    image: "/image/e1_worker.png",
    countKey: "comerzzia",
    subcards: [
      {
        name: "Aplicações",
        image: "/image/iconapp.png",
        href: "/comerzzia/aplicacoes",
        permission: "comerzzia-aplicacoes",
      },
      {
        name: "Grupos",
        image: "/image/groups.png",
        href: "/comerzzia/grupos",
        permission: "comerzzia-grupos",
      },
      {
        name: "Notificações",
        image: "/image/notificacao.png",
        href: "/comerzzia/notificacoes",
        permission: "comerzzia-notificacoes",
        countKey: "comerzziaNotificacoes",
      },
      {
        name: "Dashboard",
        image: "/image/icondashboard.png",
        href: "/comerzzia/dashboard",
        permission: "comerzzia-dashboard",
      },
      {
        name: "Utilização",
        image: "/image/usage.png",
        href: "/comerzzia/usage",
        permission: "comerzzia-usage",
      },
      {
        name: "Worker",
        image: "/image/worker.png",
        href: "/comerzzia/worker",
        permission: "comerzzia-worker",
      },
    ],
  },
  {
    name: "",
    permission: "ifs",
    image: "/image/IFS_Logo_Positive_RGB.png",
    countKey: "ifs",
    subcards: [
      {
        name: "Aplicações",
        image: "/image/iconapp.png",
        href: "/ifs/aplicacoes",
        permission: "ifs-aplicacoes",
      },
      {
        name: "Grupos",
        image: "/image/groups.png",
        href: "/ifs/grupos",
        permission: "ifs-grupos",
      },
      {
        name: "Fila de Integração",
        image: "/image/queue.png",
        href: "/ifs/queue",
        permission: "ifs-fila",
      },
      {
        name: "Logs",
        image: "/image/logs.png",
        href: "/ifs/logs",
        permission: "ifs-logs",
      },
      {
        name: "Sincronizar Estoque",
        image: "/image/sync.png",
        href: "/ifs/sincronizar-estoque",
        permission: "ifs-sync-estoque",
      },
    ],
  },
  {
    name: "",
    permission: "econodata",
    image: "/image/econodata.png",
    subcards: [
      {
        name: "Consulta CNPJ",
        image: "/image/documentoIcon.png",
        href: "/econodata/import",
      },
    ],
  },
  {
    name: "",
    permission: "ariba",
    image: "/image/sap-ariba-logo-web.svg",
    countKey: "ariba",
    subcards: [
      {
        name: "Empresas",
        image: "/image/folder.png",
        href: "/ariba/sourcing",
        permission: "ariba-empresas",
      },
      {
        name: "Grupos",
        image: "/image/groups.png",
        href: "/ariba/sourcing/grupos",
        permission: "ariba-grupos",
      },
      {
        name: "Logs",
        image: "/image/logs.png",
        href: "/ariba/logs",
        permission: "ariba-logs",
      },
      {
        name: "Reprocessamento",
        image: "/image/reprocess.png",
        href: "/ariba/response-errors",
        permission: "ariba-reprocessamento",
      },
      {
        name: "Dashboard Métricas",
        image: "/image/icondashboard.png",
        href: "/ariba/metrics",
        permission: "ariba-dashboard-metricas",
      },
    ],
  },
  {
    name: "",
    permission: "senior",
    image: "/image/logo-senior-site-300x124.png",
    countKey: "senior",
    subcards: [
      {
        name: "WMS",
        image: "/image/iconfornecedor.png",
        href: "/senior/wms",
        permission: "senior-wms",
      },
      {
        name: "Grupos",
        image: "/image/groups.png",
        href: "/senior/wms/grupos",
        permission: "senior-grupos",
      },
      {
        name: "Logs",
        image: "/image/logs.png",
        href: "/senior/wms/logs",
        permission: "senior-logs",
      },
      {
        name: "Dashboard Métricas",
        image: "/image/icondashboard.png",
        href: "/senior/wms/dashboard",
        permission: "senior-wms-metrics",
      },
      {
        name: "Notificações",
        image: "/image/notificacao.png",
        href: "/senior/wms/notificacoes",
        permission: "senior-wms-notificacoes",
        countKey: "wmsNotificacoes",
      },
    ],
  },
  {
    name: "Administração",
    permission: "admin",
    image: "/image/settings.png",
    subcards: [
      {
        name: "Usuarios",
        image: "/image/users.png",
        href: "/admin/users",
      },
      {
        name: "Concur ADM",
        image: "/image/logo-sap-concur.png",
        href: "/admin/concur",
      },
    ],
  },
];

// Mapa rota -> permissão exigida, derivado da mesma config usada para exibir
// os cards nesta página. Usado pelo guard de rotas em App.js para garantir
// que uma rota só renderiza se o usuário tiver a permissão específica dela
// (e não apenas a permissão "geral" do card pai).
export const routePermissions = cardsConfig.reduce((acc, card) => {
  (card.subcards || []).forEach((subcard) => {
    if (subcard.href) acc[subcard.href] = subcard.permission || card.permission;
  });
  return acc;
}, {});

function Main({ user }) {
  const { permission = "", nickname = "", email = "" } = user;
  const history = useHistory();
  const location = useLocation();

  // Use nickname se existir, caso contrário use a parte antes do @ do email
  const displayName = nickname || email.split('@')[0];

  const normalizedPermissions = Array.isArray(permission)
    ? permission
    : String(permission || "")
        .split("|")
        .map((perm) => perm.trim())
        .filter(Boolean);
  const permissionSet = new Set(normalizedPermissions);

  // Se o usuário tem "acesso-total", liberar todos os cards sem precisar listar cada permissão individual
  const hasFullAccess = permissionSet.has("acesso-total");
  const hasPermission = (perm) => !perm || hasFullAccess || permissionSet.has(perm);
  const permissionKey = hasFullAccess ? "acesso-total" : normalizedPermissions.join("|");

  // Ler o parâmetro 'view' da URL para manter o estado de visualização
  const urlParams = new URLSearchParams(location.search);
  const viewParam = urlParams.get('view');

  const [viewing, setViewing] = useState(() => {
    if (viewParam !== null && viewParam !== '') {
      const viewIndex = parseInt(viewParam);
      if (!isNaN(viewIndex) && viewIndex >= 0 && viewIndex < cardsConfig.length) {
        return viewIndex;
      }
    }
    return null;
  });
  const [counts, setCounts] = useState(() => {
    // Tentar carregar do cache primeiro
    const cached = sessionStorage.getItem('mainPageCounts');
    if (cached) {
      try {
        const { data, timestamp, permKey } = JSON.parse(cached);
        const cacheAge = Date.now() - timestamp;
        const CACHE_DURATION = 1 * 60 * 1000; // 1 minuto

        // Usar cache se ainda for válido e for do mesmo usuário/permissões
        if (cacheAge < CACHE_DURATION && permKey === permissionKey) {
          return data;
        }
      } catch (e) {
        sessionStorage.removeItem('mainPageCounts');
      }
    }

    // Inicializar todos os contadores com 0
    const initialCounts = {};
    cardsConfig.forEach(card => {
      if (card.countKey) {
        initialCounts[card.countKey] = 0;
      }
      if (card.subcards) {
        card.subcards.forEach(subcard => {
          if (subcard.countKey) {
            initialCounts[subcard.countKey] = 0;
          }
        });
      }
    });
    return initialCounts;
  });
  const [orderedCards, setOrderedCards] = useState(() => {
    const saved = localStorage.getItem('cardsOrder');
    if (saved) {
      try {
        const savedOrder = JSON.parse(saved);
        // Reordenar cardsConfig baseado na ordem salva
        const reorderedCards = savedOrder.map(index => cardsConfig[index]).filter(Boolean);

        // Validar se temos todos os cards
        if (reorderedCards.length === cardsConfig.length) {
          console.log('Carregando ordem salva:', reorderedCards.map(c => c.name || c.permission));
          return reorderedCards;
        } else {
          // Se não temos todos os cards, limpar localStorage e usar ordem padrão
          console.log('Ordem salva inválida, usando ordem padrão');
          localStorage.removeItem('cardsOrder');
          return cardsConfig;
        }
      } catch (e) {
        console.log('Erro ao carregar ordem salva:', e);
        localStorage.removeItem('cardsOrder');
        return cardsConfig;
      }
    }
    console.log('Nenhuma ordem salva, usando ordem padrão');
    return cardsConfig;
  });

  console.log('orderedCards:', orderedCards.length, 'cards');
  console.log('user:', user);

  useEffect(() => {
    const CACHE_KEY = 'mainPageCounts';
    const CACHE_DURATION = 1 * 60 * 1000; // 1 minuto

    // Verificar se já existe cache válido
    const cached = sessionStorage.getItem(CACHE_KEY);
    if (cached) {
      try {
        const { data, timestamp, permKey } = JSON.parse(cached);
        const cacheAge = Date.now() - timestamp;

        if (cacheAge < CACHE_DURATION && permKey === permissionKey) {
          // Cache válido, não precisa buscar novamente
          setCounts(data);
          return;
        }
      } catch (e) {
        sessionStorage.removeItem(CACHE_KEY);
      }
    }

    const fetchCounts = async () => {
      const newCounts = {};

      try {
        // Concur - getAllAplicacao
        if (hasPermission("concur")) {
          const concurRes = await fetchClient.get("/getAllAplicacao");
          newCounts.concur = concurRes.data?.value?.length || 0;
        }
      } catch (e) { console.log("Error fetching concur count", e); }

      try {
        // Viceri - /viceri/aplicacao/getAllAplicacao
        if (hasPermission("viceri")) {
          const viceriRes = await fetchClient.get("/viceri/aplicacao/getAllAplicacao");
          newCounts.viceri = viceriRes.data?.length || 0;
        }
      } catch (e) { console.log("Error fetching viceri count", e); }

      try {
        // Comerzzia - /comerzzia/getAllAplicacao
        if (hasPermission("comerzzia")) {
          const comerzziaRes = await fetchClient.get("/comerzzia/getAllAplicacao");
          newCounts.comerzzia = comerzziaRes.data?.length || 0;
        }
      } catch (e) { console.log("Error fetching comerzzia count", e); }

      try {
        // Comerzzia Notificações - /comerzzia/notificacoes
        if (hasPermission("comerzzia")) {
          const comerzziaNotifRes = await fetchClient.get("/comerzzia/notificacoes");
          newCounts.comerzziaNotificacoes = comerzziaNotifRes.data?.length || 0;
        }
      } catch (e) { console.log("Error fetching comerzzia notificacoes count", e); }

      try {
        // WMS Notificações pendentes (dia atual)
        if (hasPermission("senior")) {
          const _d = new Date();
          const startDate = new Date(_d.getFullYear(), _d.getMonth(), _d.getDate(), 0, 0, 0).toISOString();
          const endDate   = new Date(_d.getFullYear(), _d.getMonth(), _d.getDate(), 23, 59, 59).toISOString();
          const wmsNotifRes = await fetchClient.get(`/wms/notifications?notified=N&pageSize=100&startDate=${startDate}&endDate=${endDate}`);
          newCounts.wmsNotificacoes = wmsNotifRes.data?.count || wmsNotifRes.data?.items?.length || 0;
        }
      } catch (e) { console.log("Error fetching wms notificacoes count", e); }

      try {
        // Ariba - /ariba/getAll
        if (hasPermission("ariba")) {
          const aribaRes = await fetchClient.get("/ariba/getAll");
          newCounts.ariba = aribaRes.data?.length || 0;
        }
      } catch (e) { console.log("Error fetching ariba count", e); }

      try {
        // Senior WMS - /wms/getAll
        if (hasPermission("senior")) {
          const seniorRes = await fetchClient.get("/wms/getAll");
          newCounts.senior = seniorRes.data?.length || 0;
        }
      } catch (e) { console.log("Error fetching senior count", e); }

      try {
        // IFS - /ifs/getAllAplicacao
        if (hasPermission("ifs")) {
          const ifsRes = await fetchClient.get("/ifs/getAllAplicacao");
          newCounts.ifs = ifsRes.data?.length || 0;
        }
      } catch (e) { console.log("Error fetching ifs count", e); }

      // Salvar no cache
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({
        data: newCounts,
        timestamp: Date.now(),
        permKey: permissionKey
      }));

      setCounts(prev => ({ ...prev, ...newCounts }));
    };

    fetchCounts();
  }, [permissionKey]);

  // Sincronizar o state 'viewing' com a URL
  useEffect(() => {
    if (viewing !== null) {
      history.replace(`/?view=${viewing}`);
    } else {
      history.replace('/');
    }
  }, [viewing, history]);

  // Atualizar 'viewing' quando a URL mudar (botão voltar do navegador)
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const viewParam = urlParams.get('view');

    if (viewParam !== null && viewParam !== '') {
      const viewIndex = parseInt(viewParam);
      if (!isNaN(viewIndex) && viewIndex >= 0 && viewIndex < cardsConfig.length) {
        if (viewing !== viewIndex) {
          setViewing(viewIndex);
        }
      }
    } else if (viewing !== null) {
      setViewing(null);
    }
  }, [location.search]);

  const handleDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    if (result.source.index === result.destination.index) {
      return;
    }

    // Filtrar apenas cards visíveis (mesma lógica do render)
    const visibleCards = orderedCards.filter((card) => {
      // Ocultar tile admin, mas manter rotas acessíveis
      return card.permission !== "admin";
    });

    const items = Array.from(visibleCards);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    // Atualizar orderedCards mantendo cards não visíveis na ordem original
    const hiddenCards = orderedCards.filter((card) => {
      // Cards ocultos (admin)
      return card.permission === "admin";
    });

    const newOrderedCards = [...items, ...hiddenCards];
    setOrderedCards(newOrderedCards);

    // Salvar ordem no localStorage
    const orderIndexes = newOrderedCards.map(card => cardsConfig.findIndex(c => c === card));
    localStorage.setItem('cardsOrder', JSON.stringify(orderIndexes));

    console.log('Cards reordenados:', newOrderedCards.map(c => c.name || c.permission));
  };

  const getViewingTitle = () => {
    if (viewing === null) return null;
    const card = orderedCards.find(c => cardsConfig.findIndex(cc => cc === c) === viewing);
    if (!card) {
      // Fallback para cardsConfig se não encontrar em orderedCards
      return cardsConfig[viewing]?.name || "Menu";
    }
    return card.name || "Menu";
  };

  return (
    <>
      <GlobalStyle />
      <Container>
        <Content>
          <PageHeader>
            {viewing !== null && (
              <BackButton onClick={() => setViewing(null)}>
                <ArrowBack />
              </BackButton>
            )}
            <div>
              <PageTitle>
                {viewing !== null ? getViewingTitle() : "Portal de Aplicações"}
              </PageTitle>
              <PageSubtitle>
                {viewing !== null
                  ? "Selecione uma opção para continuar"
                  : `Bem-vindo de volta, ${displayName}. Selecione um serviço para acessar.`}
              </PageSubtitle>
            </div>
          </PageHeader>

          <CardRow>
            {viewing === null ? (
              <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="cards">
                  {(provided, droppableSnapshot) => (
                    <Cards
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      isDraggingOver={droppableSnapshot.isDraggingOver}
                    >
                      {orderedCards.filter((card) => {
                        // Ocultar tile admin, mas manter rotas acessíveis
                        return card.permission !== "admin";
                      }).map((card, index) => {
                        const hasAccess = hasPermission(card.permission);

                        const cardCount = card.countKey ? counts[card.countKey] : undefined;
                        const originalIndex = cardsConfig.findIndex(c => c === card);

                        return (
                          <Draggable
                            key={`card-${originalIndex}`}
                            draggableId={`card-${originalIndex}`}
                            index={index}
                            isDragDisabled={!hasAccess}
                          >
                            {(provided, snapshot) => (
                              <>
                                <DraggableWrapper
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  isDragging={snapshot.isDragging}
                                >
                                  <CardAplicacao
                                    onClick={() => hasAccess && !snapshot.isDragging && setViewing(originalIndex)}
                                    index={index}
                                    disabled={!hasAccess}
                                    isDragging={snapshot.isDragging}
                                  >
                                    {cardCount !== undefined && card.permission !== "admin" && (
                                      <Counter>{cardCount}</Counter>
                                    )}
                                    <CardVisual disabled={!hasAccess}>
                                      <CardImageWrapper disabled={!hasAccess}>
                                        {card.permission === "admin" ? (
                                          <AdminIcon disabled={!hasAccess}>
                                            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                                              <path d="M8 11h8"></path>
                                              <path d="M12 15V7"></path>
                                            </svg>
                                          </AdminIcon>
                                        ) : (
                                          <CardLogo
                                            src={card.image}
                                            alt={card.name}
                                            disabled={!hasAccess}
                                            style={card.permission === "comerzzia" ? { width: "100%", maxHeight: "160px" } : {}}
                                          />
                                        )}
                                      </CardImageWrapper>
                                      {!hasAccess && (
                                        <LockOverlay>
                                          <LockOutlinedIcon style={{ fontSize: 42 }} />
                                        </LockOverlay>
                                      )}
                                    </CardVisual>
                                    {card.name && (
                                      <CardTitle disabled={!hasAccess}>{card.name}</CardTitle>
                                    )}
                                  </CardAplicacao>
                                </DraggableWrapper>
                              </>
                            )}
                          </Draggable>
                        );
                      })}
                      {provided.placeholder}
                    </Cards>
                  )}
                </Droppable>
              </DragDropContext>
            ) : (
              <Cards>
                {(() => {
                  const currentCard = orderedCards.find(c => cardsConfig.findIndex(cc => cc === c) === viewing) || cardsConfig[viewing];
                  if (!currentCard || !currentCard.subcards) return null;

                  return currentCard.subcards.map((subcard, idx) => {
                    const hasSubcardAccess = hasPermission(subcard.permission);
                    const subcardCount = subcard.countKey ? counts[subcard.countKey] : undefined;

                    return (
                      <SubcardWrapper key={idx}>
                        <CardAplicacao
                          index={idx}
                          disabled={!hasSubcardAccess}
                          onClick={(e) => {
                            if (!hasSubcardAccess) {
                              e.preventDefault();
                            }
                          }}
                        >
                          {subcardCount !== undefined && (
                            <Counter>{subcardCount || 0}</Counter>
                          )}
                          <LinkSt
                            to={hasSubcardAccess ? subcard.href : "#"}
                            onClick={(e) => {
                              if (!hasSubcardAccess) {
                                e.preventDefault();
                              }
                            }}
                          >
                            <CardVisual disabled={!hasSubcardAccess}>
                              <CardImageWrapper disabled={!hasSubcardAccess}>
                                <CardLogo
                                  src={subcard.image}
                                  alt={subcard.name}
                                  disabled={!hasSubcardAccess}
                                />
                              </CardImageWrapper>
                              {!hasSubcardAccess && (
                                <LockOverlay>
                                  <LockOutlinedIcon style={{ fontSize: 42 }} />
                                </LockOverlay>
                              )}
                            </CardVisual>
                            <CardTitle disabled={!hasSubcardAccess}>{subcard.name}</CardTitle>
                          </LinkSt>
                        </CardAplicacao>
                      </SubcardWrapper>
                    );
                  });
                })()}
              </Cards>
            )}
          </CardRow>
        </Content>
      </Container>
    </>
  );
}

export default Main;

// Animações
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const scaleIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const LinkSt = styled(Link)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: inherit;
`;

const Container = styled.div`
  background-color: #f3f4f6;
  min-height: calc(100vh - 65px);
  box-sizing: border-box;
  font-family: "Mulish", sans-serif;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;

const PageHeader = styled.div`
  margin-bottom: 2.5rem;
  display: flex;
  align-items: flex-start;
  gap: 16px;
`;

const PageTitle = styled.h1`
  font-size: 1.8rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 0.5rem 0;
  font-family: "Mulish", sans-serif;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const PageSubtitle = styled.p`
  font-size: 1rem;
  color: #6b7280;
  margin: 0;
  font-family: "Mulish", sans-serif;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;


const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  padding: 3rem 2rem;

  @media (max-width: 768px) {
    padding: 2rem 1rem;
  }
`;

const BackButton = styled.button`
  background: rgba(102, 126, 234, 0.1);
  border: none;
  border-radius: 12px;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #667eea;
  transition: all 0.3s ease;
  flex-shrink: 0;

  &:hover {
    background: rgba(102, 126, 234, 0.2);
    transform: translateX(-4px);
  }

  &:active {
    transform: translateX(0);
  }
`;

const CardRow = styled.div`
  display: flex;
  flex-direction: column;
`;

const Cards = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 1200px;
  margin: 0 auto;
  gap: 24px;
  width: 100%;
  animation: ${fadeIn} 0.8s ease;
  min-height: 200px;
  position: relative;

  /* Estilo para o placeholder do react-beautiful-dnd */
  & > div[data-rbd-placeholder-context-id] {
    flex: 0 0 calc(25% - 18px) !important;
    min-width: 180px !important;
    max-width: calc(25% - 18px) !important;

    @media (max-width: 1200px) {
      flex: 0 0 calc(25% - 15px) !important;
      max-width: calc(25% - 15px) !important;
    }

    @media (max-width: 768px) {
      flex: 0 0 calc(50% - 7.5px) !important;
      max-width: calc(50% - 7.5px) !important;
    }
  }

  @media (max-width: 1200px) {
    gap: 20px;
  }

  @media (max-width: 768px) {
    gap: 15px;
  }

  @media (max-width: 480px) {
    gap: 15px;
  }
`;

const DraggableWrapper = styled.div`
  flex: 0 0 calc(25% - 18px);
  min-width: 180px;
  max-width: calc(25% - 18px);
  box-sizing: border-box;

  @media (max-width: 1200px) {
    flex: 0 0 calc(25% - 15px);
    max-width: calc(25% - 15px);
  }

  @media (max-width: 768px) {
    flex: 0 0 calc(50% - 7.5px);
    max-width: calc(50% - 7.5px);
  }

  @media (max-width: 480px) {
    flex: 0 0 calc(50% - 7.5px);
    max-width: calc(50% - 7.5px);
  }
`;

const SubcardWrapper = styled.div`
  flex: 0 0 calc(25% - 18px);
  min-width: 180px;
  max-width: calc(25% - 18px);
  box-sizing: border-box;

  @media (max-width: 1200px) {
    flex: 0 0 calc(25% - 15px);
    max-width: calc(25% - 15px);
  }

  @media (max-width: 768px) {
    flex: 0 0 calc(50% - 7.5px);
    max-width: calc(50% - 7.5px);
  }

  @media (max-width: 480px) {
    flex: 0 0 calc(50% - 7.5px);
    max-width: calc(50% - 7.5px);
  }
`;

const CardAplicacao = styled.div`
  background: white;
  border-radius: 16px;
  padding: 2rem 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "grab")};
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  border: 1px solid #e5e7eb;
  height: 150px;
  width: 100%;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
  animation: ${scaleIn} 0.5s ease;
  animation-delay: ${(props) => props.index * 0.05}s;
  animation-fill-mode: both;
  position: relative;
  opacity: ${(props) => (props.disabled ? 0.65 : 1)};
  filter: ${(props) => (props.disabled ? "grayscale(25%)" : "none")};
  overflow: hidden;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    top: 8px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 4px;
    background: ${(props) => (props.isDragging ? "#667eea" : "transparent")};
    border-radius: 2px;
    transition: all 0.2s ease;
    opacity: ${(props) => (props.isDragging ? 1 : 0)};
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 3px;
    background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
    border-radius: 3px 3px 0 0;
    transition: width 0.3s ease;
  }

  ${(props) =>
    props.disabled &&
    `
      background: #f1f3f8;
      border: 2px dashed #cbd5e1;
      box-shadow: none;

      &::after {
        display: none;
      }
    `}

  ${(props) =>
    !props.disabled &&
    !props.isDragging &&
    `
    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
      border-color: #e5e7eb;

      &::after {
        width: 60%;
      }
    }
  `}

  ${(props) =>
    props.isDragging &&
    `
    &::after {
      width: 100%;
      background: #667eea;
    }
  `}

  a {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  @media (max-width: 768px) {
    padding: 1.5rem 1rem;
  }
`;

const Counter = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  background-color: #ef4444;
  color: white;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 2px 16px;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.3);
`;

const LockOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background: rgba(15, 23, 42, 0.2);
  color: #1f2933;
`;

const CardVisual = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const CardImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 1rem;
  transition: filter 0.3s;
  opacity: ${(props) => (props.disabled ? 0.45 : 1)};
  filter: ${(props) => (props.disabled ? "grayscale(80%)" : "grayscale(0%)")};

  ${(props) =>
    !props.disabled &&
    `
    ${CardAplicacao}:hover & {
      filter: grayscale(0%);
    }
  `}
`;

const CardLogo = styled.img`
  max-width: 80%;
  max-height: 80px;
  object-fit: contain;
  transition: filter 0.3s;
`;

const CardTitle = styled.h4`
  font-size: 14px;
  font-weight: 700;
  color: ${(props) => (props.disabled ? "#97a3b6" : "#2c3e50")};
  text-align: center;
  margin: 0;
  font-family: "Mulish", sans-serif;
  line-height: 1.4;
  transition: color 0.3s ease;

  ${(props) =>
    !props.disabled &&
    `
    ${CardAplicacao}:hover & {
      color: #667eea;
    }
  `}

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const AdminIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.disabled ? "#97a3b6" : "#2c3e50")};
  transition: all 0.3s ease;

  svg {
    filter: ${(props) => (props.disabled ? "grayscale(80%)" : "grayscale(0%)")};
    opacity: ${(props) => (props.disabled ? 0.45 : 1)};
  }

  ${(props) =>
    !props.disabled &&
    `
    ${CardAplicacao}:hover & {
      color: #1f2933;
      transform: scale(1.05);
    }
  `}
`;
